module.exports = __webpack_public_path__ + "3977e7fd544066a6e0fcc8120022d5c6.jpg";